"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SubNavPanel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _golfToEid = _interopRequireDefault(require("@gd-internal/golf-to-eid"));
var _link = _interopRequireDefault(require("@ux/link"));
var _reactMintl = require("@godaddy/react-mintl");
var _x = _interopRequireDefault(require("@ux/icon/x"));
var _chevronLeft = _interopRequireDefault(require("@ux/icon/chevron-left"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class SubNavPanel extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {};
  }

  /**
   * Render a uxcore2 icon
   * @param {string} icon The classname for a uxcore2 icon
   * @returns {React.Element} A span with an icon
   * @private
   */
  renderIcon(icon) {
    if (icon) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(icon, 'uxicon', 'custom-icon')
      });
    }
    return null;
  }

  /**
   * handles clicking on navigation items with a custom onClick handler
   *
   * @param {Object} item The item that was just clicked on
   * @param {Object} event The click event
   * @private
   */
  onItemClick(item, event) {
    if (typeof item.onClick === 'function') {
      item.onClick(event);
    }
    this.afterItemClicked(item);
  }

  /**
   * Performs actions after clicking on an item
   *
   * @param {Object} item The item that was just clicked on
   * @private
   */
  afterItemClicked(item) {
    if (typeof document !== 'undefined') {
      window.sessionStorage.setItem('activeCaption', item.caption || item.id);
    }
    this.props.onClose();
  }

  /**
   * Generate links
   *
   * @private
   * @param {Array} items Array of objects to display as links
   * @returns {Array} a set of Links
   */
  renderMobileLinks(items) {
    const links = [];
    items.forEach((child, i) => {
      if (!child.href || child.href.length === 0 || child.desktopOnly) {
        return;
      }
      const active = this.props.currentHref === child.href;
      const eid = child.eid || (0, _golfToEid.default)(child.caption || child.id || '', {
        prefix: this.props.eidPrefix,
        postfix: 'link.click'
      });
      if (child.caption || child.title) {
        links.push(/*#__PURE__*/_react.default.createElement("li", {
          key: (child.caption || child.id) + i,
          className: (0, _classnames.default)('subnav-item', {
            active
          })
        }, /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
          href: child.href,
          target: child.target,
          "data-eid": eid,
          onClick: child.onClick && this.onItemClick.bind(this, child),
          onClicked: () => this.afterItemClicked(child),
          urlArgs: this.props.urlArgs
        }, child.dataAttrs), child.title || child.caption, this.renderIcon(child.icon))));
      }
    });
    return links;
  }

  /**
   * Generate secondary headings for each section of links inside primary heading
   *
   * @private
   * @param {Object[]} items Array of objects for generating the subnav links
   * @param {String} parentHeading The caption for the parent of the subnav-panel
   * @returns {ReactElement[]} a set of list items
   */
  renderSubNavSections(items, parentHeading) {
    const listItems = [];
    items.forEach((child, i) => {
      // if there are subsections, i.e. two levels of children
      if (child.children && child.children.length > 0) {
        const suppressTitle = items.length === 1 && child.title && child.title === parentHeading;

        // check if the children are valid links
        const links = this.renderMobileLinks(child.children);
        if (!Array.isArray(links) || links.length === 0) {
          return;
        }
        // push the heading first
        if (!suppressTitle && (child.caption || child.title)) {
          listItems.push(/*#__PURE__*/_react.default.createElement("li", {
            key: (child.caption || child.id) + i,
            className: "subnav-mobile-heading"
          }, child.title || child.caption));
        }
        // then push the links
        listItems.push(links);
        // then push divider
        listItems.push(/*#__PURE__*/_react.default.createElement("hr", {
          key: 'hr' + i
        }));
      }
    });
    if (listItems.length === 0) {
      // no subsections
      listItems.push(this.renderMobileLinks(items));
    }
    return listItems;
  }

  /**
   * Generate subnav for a primary heading
   *
   * @private
   * @param {Object} navSection Object for generating the subnav
   * @param {String} navSection.caption Text for primary heading in subnav
   * @param {Object[]} navSection.children Array of objects for generating the subnav sections
   * @param {String} [navSection.href] href for heading to link to
   * @returns {ReactElement} a div containing the subnav for a primary heading
   */
  renderNavSection(navSection) {
    let colHeading;
    const {
      caption,
      title,
      id,
      href,
      dataAttrs,
      target,
      onClick
    } = navSection;
    if (href) {
      const eid = navSection.eid || (0, _golfToEid.default)(caption || id || '', {
        prefix: this.props.eidPrefix,
        postfix: 'link.click'
      });
      colHeading = /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
        href: href,
        "data-eid": eid,
        target: target,
        onClick: onClick && this.onItemClick.bind(this, navSection),
        onClicked: this.props.onClose
      }, dataAttrs), title || caption);
    } else {
      colHeading = title || caption;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "subnav-scroller"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      ref: r => {
        this.element = r;
      },
      className: "subnav-mobile"
    }, /*#__PURE__*/_react.default.createElement("li", {
      className: "column-heading"
    }, colHeading, this.renderIcon(navSection.icon)), this.renderSubNavSections(navSection.children, colHeading)));
  }

  /**
   * render gray header with close button
   * and conditionally a back button
   *
   * @param {Boolean} showBackBtn Whether or not to show the back button
   * @private
   * @returns {ReactElement} a div for the top header
   */
  renderTopContainer(showBackBtn) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mobile-top-container"
    }, showBackBtn && /*#__PURE__*/_react.default.createElement("button", {
      onClick: this.props.onBack,
      className: "main-menu-btn"
    }, /*#__PURE__*/_react.default.createElement(_chevronLeft.default, {
      width: 12,
      height: 12
    }), this.props.menuTitle), /*#__PURE__*/_react.default.createElement("span", {
      onClick: this.props.onClose,
      className: "close-button"
    }, /*#__PURE__*/_react.default.createElement(_x.default, {
      width: 24,
      height: 24
    })));
  }

  /**
   * Render panel displaying subnav if navigation menu is open
   *
   * @private
   *
   * @returns {ReactElement} div for the subnav panel
   */
  render() {
    const {
      props
    } = this;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('subnav-panel', {
        open: props.open
      })
    }, this.renderTopContainer(true), this.renderNavSection(props.navigation));
  }
}

/**
 * PropType validation for SubNavPanel
 *
 * @type {Object}
 * @api public
 */
exports.SubNavPanel = SubNavPanel;
SubNavPanel.propTypes = {
  currentHref: _propTypes.default.string,
  eidPrefix: _propTypes.default.string,
  menuTitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.instanceOf(_reactMintl.FormattedMessage)]),
  navigation: _propTypes.default.object.isRequired,
  onBack: _propTypes.default.func,
  onClose: _propTypes.default.func,
  open: _propTypes.default.bool,
  urlArgs: _propTypes.default.object
};

/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */
SubNavPanel.defaultProps = {
  currentHref: '',
  eidPrefix: 'uxp.hyd.mobile_nav',
  menuTitle: /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "Shared:MobileNav:MainMenu"
  }),
  onBack: () => {},
  onClose: () => {},
  open: false
};
var _default = exports.default = SubNavPanel;